export enum ErrorMessages {

  //#region
  SiteNotAssigned = 'No site is assigned to you. Kindly contact application administrator.',
  //#endregion

  //#region PROJECT
  ProjectNotAssigned = 'No project is assigned to you. Kindly contact application administrator.',
  //#endregion

  //#region BOOKING
  BookingGetError = "Could not get booking details.",
  //#endregion

  //#region Measurement
  GetMeasurementIdError = "Could not get measurement Details",
  //#endregion

  //#region Measurement
  GetUnitSizeDetailError = "Could not get measurement Details",
  //#endregion

  //#region Booking
  bookingAdd = "Booking created succcesfully",
  bookingUpdate = "Booking updated succcesfully",
  unitCategoryValidation = "All units of this category is already booked or alloted",
  cancelledBooking = 'Booking is cancelled successfully.',
  bookingCancellationRequest = 'Booking cancellation request submitted successfully.',
  //#endregion
  //#region Allotment
  cancelledAllotment = 'Allotment is cancelled successfully.',
  //#endregion

  //#region for input
  CorrectFormat = "Enter the value in correct format",
  RequiredField = "This field is required",
  //#endregion

  //#region export alert message
  minimumExport = "At least one record should be selected",
  //#endregion

  AccessDenied = "You're not authorise to view this page, Kindly contact your application administrator.",

  GeneralError = "Something went wrong, please contact application administrator."
}